import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  apiUrl: 'https://api-crm.new-time.dev.tes.store',
  production: false,
  isLocal: false,
  clientPlatformUrl: 'https://new-time.dev.tes.store',
  envLabel: 'DEV',
};
